import React from 'react';
import { FormProvider as Form } from 'react-hook-form';

const FormProviderMC = ({
  children, onSubmit, methods, className, id
}) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Form {...methods}>
    <form className={className} onSubmit={onSubmit} id={id}>{children}</form>
  </Form>
);

export default FormProviderMC;
